/**
 * State management constants and configuration
 */

export const CART_STORAGE_KEY = process.env.GATSBY_CART_NAME

export const STOREFRONT_CONFIG = {
  storeDomain: "https://" + process.env.GATSBY_SHOPIFY_STORE_URL,
  apiVersion: "2025-10",
  publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
}

/**
 * Error Monitoring & Analytics Alternatives (Free/Cheap with Great Visuals):
 *
 * 1. Sentry (https://sentry.io) - FREE tier: 5K errors/month
 *    - Excellent error tracking with beautiful dashboards
 *    - Source maps, stack traces, user context
 *    - Performance monitoring included
 *    - Easy React integration: @sentry/react
 *
 * 2. PostHog (https://posthog.com) - FREE tier: 1M events/month
 *    - Product analytics + error tracking in one
 *    - Session replay, feature flags, A/B testing
 *    - Great for small businesses - see user journeys
 *
 * 3. LogRocket (https://logrocket.com) - FREE tier: 1K sessions/month
 *    - Session replay + error tracking
 *    - See exactly what users see when errors occur
 *    - Redux/state inspection built-in
 *
 * 4. Better Stack (https://betterstack.com) - FREE tier: 10 monitors
 *    - Uptime monitoring + error tracking
 *    - Beautiful status pages
 *    - Incident management
 *
 * 5. Plausible Analytics (https://plausible.io) - €9/month
 *    - Privacy-focused, GDPR compliant
 *    - Simple, beautiful dashboards
 *    - No cookies, lightweight
 *
 * Recommendation: Sentry for errors + PostHog for analytics (both free tiers)
 *
 * Note: OpenTelemetry tracing is now configured in gatsby-node.js for server-side/build-time monitoring
 */

export const CURRENCY_CONFIG = {
  id: "GBP",
  format: "£",
}

export const DEFAULT_ADDRESS = {
  address1: "",
  address2: "",
  city: "",
  locality: "",
  zip: "",
  country_code: "GB",
}

export const EMPTY_CALCULATION = {
  calculated: false,
  name: "",
  value: 0,
}

export const EMPTY_PROMO_CODE = {
  promo_code: "",
  applied: false,
  validCode: true,
  validated: true,
}
